module.exports = __webpack_public_path__ + "14-o2.jpg?477da1c07e603bb7d9238c290afce9b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/14-o2.jpg
// module id = 627
// module chunks = 0